import isTouchDevice from 'is-touch-device';

const AutoFocusIfNonTouchDevice = ({ children }) => children(!isTouchDevice());

export default AutoFocusIfNonTouchDevice;
